import * as Sentry from '@sentry/react'
import { SupabaseClient } from '@supabase/supabase-js'
import { supabaseIntegration } from '@supabase/sentry-js-integration'

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL

export function initSentry() {
  if (!import.meta.env.VITE_SENTRY_DSN) return
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE,
    integrations: [
      Sentry.browserTracingIntegration({
        // Prevent duplicate spans — supabaseIntegration already traces DB calls
        shouldCreateSpanForRequest: (url) => !url.startsWith(`${SUPABASE_URL}/rest`),
      }),
      supabaseIntegration(SupabaseClient, Sentry, {
        tracing: true,
        breadcrumbs: true,
        errors: true,
      }),
    ],
    tracesSampleRate: 0.2,
  })
}

export { Sentry }
